import styled from 'styled-components'

const GenericColumn = styled.div`
  width: ${(props) => (props.width ? props.width : '100%')};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : 'unset')};
  height: ${(props) => (props.height ? props.height : 'unset')};
  flex-wrap: ${(props) => (props.wrap ? 'wrap' : 'unset')};
  min-height: ${(props) => (props.minHeight ? props.minHeight : 'unset')};
  display: flex;
  flex-direction: ${(props) => (props.flexDir ? props.flexDir : 'column')};
  justify-content: ${(props) => (props.justify ? props.justify : 'center')};
  align-items: ${(props) => (props.align ? props.align : 'center')};
  position: ${(props) => (props.position ? props.position : 'relative')};
  top: ${(props) => (props.top ? props.top : 'unset')};
  left: ${(props) => (props.left ? props.left : 'unset')};
  right: ${(props) => (props.right ? props.right : 'unset')};
  bottom: ${(props) => (props.bottom ? props.bottom : 'unset')};
  padding: ${(props) => (props.padding ? props.padding : 'unset')};
  box-sizing: border-box;
  margin: ${(props) => (props.margin ? props.margin : 'unset')};
  align-self: ${(props) => (props.alignSelf ? props.alignSelf : 'unset')};
  order: ${(props) => (props.order ? props.order : 'unset')};
  z-index: ${(props) => (props.zIndex ? props.zIndex : 'unset')};
  overflow: ${(props) => (props.overflow ? props.overflow : 'unset')};

  &.right-border {
    border-right: 2px solid #e6e6e6;

    &:nth-of-type(2) {
      @media screen and (max-width: 1000px) {
        border-right: 2px solid #e6e6e6;
      }
      border-right: 0px;
    }
  }

  &.collapsable {
    transition: all 0.3s ease-in, all 0.3s ease-out;

    .ReactCollapse--collapse {
      height: auto;
      overflow: initial;
      position: absolute;
      top: 73%;
      transition: all 0.3s ease-in, all 0.3s ease-out;

      z-index: 3;
    }
  }

  .icon-green {
    fill: #a1ff68;
    cursor: pointer;
  }

  &.pointer {
    cursor: pointer;
  }

  &.miazga-app-video {
    /* width:50%; */
    margin: 0 auto;

    &.mainpage-header-row {
      width: 60%;

      @media screen and (max-width: 1200px) {
        width: 90%;
      }
      @media screen and (max-width: 600px) {
        width: 100%;
      }
    }

    video {
      border-radius: 30px;
    }
  }

  &.element-col {
    opacity: 0;
    transition: all 0.8s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  &.visible {
    opacity: 1;
  }

  &.hero-column-left {
    width: 50%;
    @media screen and (max-width: 600px) {
      display: none;
    }

    &.isTablet {
      display: none;
    }
  }

  &.hero-column-right {
    &.isTablet {
      width: 100%;
    }

    width: 50%;

    @media screen and (max-width: 600px) {
      width: 100%;
    }

    /* width: 920px;
    @media (max-width: 1920px){
      width: 540px;
    }

    @media (max-width: 768px){
      width: 100%;
    }

@media (max-width: 600px){
  width: 100%;
} */
  }

  &.platforms-section-text {
    @media (min-width: 1921px) {
      width: 40%;
    }
  }

  &.platforms-section-image {
    @media (min-width: 1921px) {
      width: 60%;
    }
  }

  &.opacity-background {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 19px;
  }

  &.diet-meal-details-left-col {
    border-right: 1px solid rgba(255, 255, 255, 0.4);
  }

  &.training-time-reminder {
    input {
      @media only screen and (max-width: 600px) {
        opacity: 1;
      }
    }
  }

  &.diet-items-overflow {
    max-height: 15vh;
    overflow: auto;
    padding: 3% 0;
    box-sizing: content-box;

    /* width */
    ::-webkit-scrollbar {
      width: 8px;
      box-sizing: border-box;
      height: 25px;
    }

    /* Track */
    ::-webkit-scrollbar-track {
      background: transparent;
    }

    /* Handle */
    ::-webkit-scrollbar-thumb {
      background-color: white;
      border-radius: 4px;
      height: 25px;
    }

    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
`

export default GenericColumn
